import Button from "@mui/material/Button";
import { DropzoneDialog } from "material-ui-dropzone";
import { useContext, useEffect, useState } from "react";
import { ApiContext } from "../../account/authenticatedAPI";
import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface FileUploadProps {
  label: React.ReactNode;
  acceptedFiles: string[];
  id: number;
  onChange: (newId: number) => void;
  image?: boolean;
  /** format attendu (« 16 / 9 », « 4 / 5 ») : libellé, aperçu à ce format (vide s'il n'y a pas d'image), puis bouton */
  ratio?: string;
}
function FileUpload({
  label,
  acceptedFiles,
  id,
  onChange,
  image = false,
  ratio,
}: FileUploadProps) {
  const [open, setOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachment, setAttachment] = useState(undefined);
  const api = useContext(ApiContext);

  useEffect(() => {
    // @ts-ignore
    if (id > 0 && (attachment === undefined || attachment.id !== id)) {
      api.then((api) =>
        api
          .media()
          .id(id)
          .then((res) => {
            setLoading(true);
            setAttachment(res);
          })
      );
    } else setLoading(false);
  }, [api, id, attachment, setAttachment]);
  // @ts-ignore
  const preview: string | undefined = attachment?.media_details?.sizes?.medium?.source_url ?? attachment?.source_url;
  return (
    <>
      {ratio ? (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">{label}</Typography>
          <Box
            sx={{
              height: 160, aspectRatio: ratio, my: 1, mx: "auto", borderRadius: 1, overflow: "hidden",
              display: "grid", placeItems: "center",
              bgcolor: "action.hover", border: 1, borderStyle: "dashed", borderColor: "divider",
            }}
          >
            {uploading || (id > 0 && !preview) ? (
              <CircularProgress />
            ) : preview ? (
              <img alt="" src={preview} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              <Typography variant="caption" color="text.secondary">Aucune image</Typography>
            )}
          </Box>
          <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
            {preview ? "Modifier l'image" : "Ajouter une image"}
          </Button>
        </Box>
      ) : (
      <Grid container spacing={2}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            {label}
          </Button>
        </Grid>
        <Grid item>{(loading || uploading) && <CircularProgress />}</Grid>
        <Grid item>
          {attachment !== undefined &&
            (image ? (
              <img
                // @ts-ignore
                alt={attachment.title.rendered}
                // @ts-ignore
                src={attachment.media_details.sizes.medium.source_url}
              />
            ) : (
              // @ts-ignore
              <a href={attachment.source_url}>
                {
                  // @ts-ignore
                  attachment.title.rendered
                }
              </a>
            ))}
        </Grid>
      </Grid>
      )}
      <DropzoneDialog
        acceptedFiles={acceptedFiles}
        cancelButtonText={"annuler"}
        submitButtonText={"envoyer"}
        dialogTitle="Envoyer un fichier"
        dropzoneText="Déposez un fichier ici ou cliquez"
        maxFileSize={5000000}
        filesLimit={1}
        open={open}
        onClose={() => setOpen(false)}
        showAlerts={false}
        onSave={(files) => {
          setOpen(false);
          setUploading(true);
          api.then((api) =>
            api
              .media()
              .file(files[0])
              .create({})
              .then((res) => {
                setUploading(false);
                setAttachment(res);
                onChange(res.id);
              })
          );
        }}
        showPreviews={true}
        showFileNamesInPreview={true}
      />
    </>
  );
}

export default FileUpload;
